import {DialogPanel} from '@headlessui/react'
import {motion} from 'framer-motion'

import {twMerge} from '@sdox/utils'

import {RightAnimation} from '../../../animations'

import type {PropsWithChildren} from 'react'

export enum PanelSizeEnum {
  TOC = 'toc',
  LARGE = 'large',
}

export interface PanelProps extends PropsWithChildren {
  size?: PanelSizeEnum
  className?: string
}

const SizeClassMap: Record<PanelSizeEnum, string> = {
  toc: 'ml-spacing-48 md:ml-auto max-w-[340px] md:max-w-[440px]',
  large: 'sm:w-3/4 lg:w-2/3',
}

export const Panel = ({
  size = PanelSizeEnum.LARGE,
  className,
  children,
}: PanelProps) => (
  <motion.div
    className={
      twMerge(
        'fixed right-0 z-[70] h-screen',
        SizeClassMap[size],
        className,
      )
    }
    transition={{bounce: 0, duration: 0.3, ease: 'easeOut'}}
    {...RightAnimation}
  >
    <DialogPanel className={'flex h-screen min-h-0 max-w-full flex-col overflow-hidden bg-surface-primary'}>
      {children}
    </DialogPanel>
  </motion.div>
)
